import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { InfoAlert, WarningAlert, WarningAlertCustom } from "@shared/ui/alerts";

import {
  signIn as signInRequest,
  checkUnsentInvoice,
  validateCurrentWeekTimesheet,
} from "../api/authApi";

import type { SignInCredentials } from "../api/authApi";

export const useSignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const invoiceUnsentAlert = (checkUnsent: string) => {
    if (checkUnsent === "Found") WarningAlert(t("warningTitle"), t("invoiceUnsent"));
  };

  const signIn = async (credentials: SignInCredentials) => {
    setIsSubmitting(true);
    try {
      const user = await signInRequest(credentials);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", JSON.stringify(user.token));

      setIsSubmitting(false);

      const checkUnsent = await checkUnsentInvoice();

      // Los martes y viernes se recuerda la carga de horas de la semana.
      const today = new Date().getDay();
      if (today === 2 || today === 5) {
        const timesheet = await validateCurrentWeekTimesheet();
        if (timesheet.isChargedHourInWeek) {
          await InfoAlert(t("weeklyHoursTitle"), timesheet.message);
          invoiceUnsentAlert(checkUnsent);
        } else {
          // `hourNotCharged` es opcional en el contrato: si el backend no lo manda, este
          // .map lanza y el login queda mostrando error pese a haberse completado. Se
          // conserva tal cual — es un fix aparte, no de la migracion.
          const template = `<p>${timesheet.message}</p><br/><ul>${timesheet.hourNotCharged!
            .map((item: string) => `<li>${item}</li>`)
            .join("")}</ul>`;
          await WarningAlertCustom(t("warningTitle"), template);
          invoiceUnsentAlert(checkUnsent);
        }
      } else {
        invoiceUnsentAlert(checkUnsent);
      }

      navigate("/people-and-culture");
    } finally {
      setIsSubmitting(false);
    }
  };

  return { signIn, isSubmitting };
};
